<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu open-on-hover bottom max-height="300px">
    <template v-slot:activator="{ on }">
      <v-btn :color="color || 'kbPurple'"
             dark
             :loading="loadingExtradatas"
             :small="$vuetify.breakpoint.smAndDown"
             v-on="on">
        <v-icon left>edit</v-icon>
        {{ $t('general.customize') }} {{ itemToCustomize || $t('general.message') }}
      </v-btn>
    </template>

    <v-list>
      <v-list-item color="kbDarkBlue"
                   v-for="(item, index) in customizationItems"
                   :key="index"
                   @click="$emit('customizeMessage', item, propModif, domElemCursorPosition, accessDataObject)">
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas
    }),
    customizationItems () {
      const nameValue = this.$route.name === 'Disparadores' ? '{{NAME}}' : '{{name}}'
      let customExtradataFields = []
      if (this.appCustomExtradatas &&
          Array.isArray(this.appCustomExtradatas) &&
          this.appCustomExtradatas.length) {
        customExtradataFields = this.appCustomExtradatas.map(extraData => {
          if (typeof extraData.name === 'string' && extraData.name.split(' ').length > 1) {
            return { label: extraData.name, value: `{{[${extraData.name}]}}` }
          } else {
            return { label: extraData.name, value: `{{${extraData.name}}}` }
          }
        })
      }
      return [
        { label: this.$t('general.name'), value: nameValue },
        { label: this.$t('general.phone'), value: '{{phone}}' },
        { label: this.$t('general.email'), value: '{{email}}' },
        ...customExtradataFields
      ]
    }
  },
  created () {
    this.getAppCustomExtradatas()
  },
  data () {
    return {
      loadingExtradatas: false
    }
  },
  methods: {
    async getAppCustomExtradatas () {
      try {
        this.loadingExtradatas = true
        await this.$store.dispatch('getAppCustomExtradatas')
        this.loadingExtradatas = false
      } catch (e) {
        this.loadingExtradatas = false
        notifications.error(e)
      }
    }
  },
  props: ['color', 'propModif', 'domElemCursorPosition', 'accessDataObject', 'itemToCustomize']
}
</script>
